export const NumberUtilsInit = () => {
  /* eslint-disable-next-line */
  Number.prototype.pad = function (size) {
    var s = String(this);
    while (s.length < (size || 2)) {
      s = '0' + s;
    }
    return s;
  };
};

export const getUniqueKey = () => {
  const atual = sessionStorage.getItem('chaveAtual')
    ? parseInt(sessionStorage.getItem('chaveAtual') ?? 0)
    : 1;
  sessionStorage.setItem('chaveAtual', String(atual + 1));
  return `_${atual}`;
};

export const getCurrencyFormat = (value, languageValues) => {
  return value.toLocaleString(languageValues.locale, {
    style: 'currency',
    currency: languageValues.currency,
  });
};

export const getCurrencyFormatProps = (languageValues) => {
  return {
    prefix: languageValues.currencyPrefix,
    thousandSeparator: '.',
    decimalSeparator: ',',
    fixedDecimalScale: true,
    decimalScale: 2,
    allowLeadingZeros: false,
    allowEmptyFormatting: true,
    isNumericString: true,
  };
};
